import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const InfoNotificationIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="info" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="Oval-Copy" fill="#A6D3F4" cx="12" cy="12" r="10"></circle>
                <path
                    d="M11,9 L11,7 L13,7 L13,9 L11,9 Z M11,18 L11,10 L13,10 L13,18 L11,18 Z"
                    id="i"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                ></path>
            </g>
        </SvgIcon>
    );
};
